import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Promo } from '../../models/promo';
import { PromoState } from '../reducers/promo';

export const getPromosStore = createFeatureSelector<PromoState>('promo');
export const getPromos = createSelector(
  getPromosStore,
  (state: PromoState): Promo[] => state.list,
);
export const getPromosStats = createSelector(
  getPromosStore,
  (state: PromoState): any => state.stats,
);
export const getPromoStats = (name: string) =>
  createSelector(getPromosStats, (stats) => stats && stats[name]);
export const arePromosLoaded = createSelector(
  getPromosStore,
  (state: PromoState): boolean => state.isLoaded,
);
export const arePromosLoading = createSelector(
  getPromosStore,
  (state: PromoState): boolean => state.isLoading,
);
export const promosReady = createSelector(
  getPromosStore,
  (state: PromoState): boolean => !state.isLoading && state.isLoaded,
);
export const areStatsLoading = createSelector(
  getPromosStore,
  (state: PromoState): boolean => state.areStatsLoading,
);
